import { render, staticRenderFns } from "./DeleteConfirmPresentations.vue?vue&type=template&id=4bea4422"
import script from "./DeleteConfirmPresentations.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmPresentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports